@if(loading === true){
<div class="progressbar-container">
  <motif-progress-bar
    [circle]="true"
    [hideLabel]="true"
    [isIndeterminate]="true"
    [tabIndex]="0"
    aria-label="Loading..."
    aria-live="polite"
  ></motif-progress-bar>
  <p progressbar-label>Loading...</p>
</div>
}
<!--  -->
@if(loading === false && contentAvailable === true){

<app-tab-list
  *ngIf="tabNumber === 4"
  [tabs]="cyvpyTabs"
  [currentTab]="innerCurrentTab"
  [size]="'medium'"
  (currentTabEmitter)="toggleTabOnNumber($event)"
></app-tab-list>

<div class="check-info-container">
  <p>Last run: {{ lastRanOn ? (lastRanOn + "Z" | date : "MMM d, y h:mma") : "" }}</p>
  <p>File name(s): {{ filenames }}</p>
</div>

<div *ngIf="!inAdjustmentsInnerTab()" class="user-guide-container">
  <div [tabIndex]="0" (keydown.enter)="openUserGuide()">
    <motif-icon
      (click)="openUserGuide()"
      [iconFunction]="IconoirOpenNewWindow"
      size="14"
    >
    </motif-icon>
    <p (click)="openUserGuide()">User guide</p>
  </div>
</div>

<div class="heading-container" [ngClass]="{ right: inAdjustmentsInnerTab() }">
  <div class="page-header" *ngIf="flaggedDataExists()">
    <h2 class="page-title no-margin-top">Flagged Items</h2>
  </div>

  <div class="right-content-container">
    <div class="check-info-container">
      <p>
        Last export:
        {{
          inAdjustmentsInnerTab()
            ? (adjustmentsLastExportedOn | date : "MMM d, y h:mma") ||
              "Has not been exported yet"
            : (lastExportedOn | date : "MMM d, y h:mma") ||
              "Has not been exported yet"
        }}
      </p>
    </div>

    <div class="buttons-container">
      <!-- Export dropdown -->
      <motif-dropdown
        aria-label="Toggle Dropdown button"
        aria-live="polite"
        [tabIndex]="0"
      >
        <motif-dropdown-trigger>
          <motif-button
            variant="primary"
            class="export-test-results-button"
            [disabled]="
              exportingLoader ||
              (inAdjustmentsInnerTab() &&
                adjustmentsTableData &&
                adjustmentsTableData.length === 0)
            "
            aria-label="Export test results"
            aria-live="polite"
          >
            @if(exportingLoader){
            <motif-progress-bar
              class="button-loader"
              [circle]="true"
              [hideLabel]="true"
              [isIndeterminate]="true"
              [tabIndex]="0"
              aria-label="Loading. Exporting test results..."
              aria-live="polite"
            ></motif-progress-bar>
            } @else{
            Export test results as..
            <motif-icon
              class="icono-dropdown"
              size="16"
              [iconFunction]="IconoirNavArrowDown"
            ></motif-icon>
            }
          </motif-button>
        </motif-dropdown-trigger>

        <motif-dropdown-content class="motif-theme-light">
          <motif-dropdown-item
            aria-label="Export as PDF"
            aria-live="polite"
            (click)="exportTestResults()"
          >
            PDF
          </motif-dropdown-item>

          <motif-dropdown-item
            aria-label="Export as Excel"
            aria-live="polite"
            (click)="exportTestResults(true)"
          >
            Excel
          </motif-dropdown-item>
        </motif-dropdown-content>
      </motif-dropdown>
      <!-- END Export dropdown -->
      <motif-button
        *ngIf="flaggedDataExists() && passedTestDataExists()"
        variant="primary"
        (click)="showOnlyFlagged()"
        [ariaLabel]="
          showOnlyFlaggedData ? 'Show all data' : 'Show only flagged'
        "
        aria-live="polite"
      >
        {{ showOnlyFlaggedData ? "Show all data" : "Show only flagged" }}
      </motif-button>
    </div>
  </div>
</div>

<div
  class="adjustment-profit-message-container"
  *ngIf="
    inAdjustmentsInnerTab() &&
    adjustmentsTableData &&
    adjustmentsTableData.length > 0
  "
>
  <p>{{ adjustmentOfProfitMessage }}</p>
</div>

<app-analysis-warning
  *ngIf="showWarning"
  #analysisWarning
  [flaggedItems]="flaggedData"
  [fullData]="tableData"
></app-analysis-warning>

<app-table
  *ngIf="flaggedDataExists()"
  [data]="flaggedData"
  [columns]="tableColumns"
  [bgClass]="{ 'background-color': '#fcf5f0', outline: '3px solid #ee8300' }"
  [ngClass]="{ 'is-zoomed': isZoomed }"
></app-table>

@if(!showOnlyFlaggedData){
<div
  class="page-header"
  *ngIf="passedTestDataExists() && inSupplementaryInnerTab()"
>
  <p class="page-title">All other items</p>
</div>

<app-table
  *ngIf="passedTestDataExists()"
  [data]="passedTestData"
  [columns]="tableColumns"
  [bgClass]="{
    'background-color': inAdjustmentsInnerTab() ? '#ffffff' : '#f4fff5'
  }"
  [headersStyle]="{
    'background-color': inAdjustmentsInnerTab() ? '#fdfdfd' : '#ffffff',
    'font-weight': inAdjustmentsInnerTab() ? '400' : 'normal'
  }"
  [ngClass]="{ 'is-zoomed': isZoomed }"
></app-table>
}

<div
  *ngIf="
    inAdjustmentsInnerTab() &&
    adjustmentsTableData &&
    adjustmentsTableData.length === 0
  "
  class="content-not-available"
>
  <h3>There is no data available for Adjustment of profit</h3>
</div>

<div class="buttons-container left">
  <motif-button
    variant="primary-alt"
    (click)="backToAgentFiveHome()"
    aria-label="Go to Corporate Income Tax Review Agent home page"
    aria-live="polite"
  >
    Corporate Income Tax Review home
  </motif-button>
  <motif-button
    variant="primary-alt"
    (click)="scrollUp()"
    aria-label="Scroll back to the top of the page"
    aria-live="polite"
  >
    Back to top
  </motif-button>
</div>
}
<!--  -->
@if(loading === false && contentAvailable === false){
<div class="content-not-available">
  <h3>
    {{ pageMessage }}
  </h3>
</div>
}
